import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';
import React from 'react';
import { useSelector } from 'react-redux';
import { getErrorSuccessLoaderLabels } from 'redux/modules/dynamicLabels/selectors';

type SuccessStatusDialogProps = {
	operationType: 'phone' | 'email' | 'password';
	onClose: () => void;
};

const labelsMap = {
	email: 'editEmailSuccess',
	phone: 'editNumberSuccess',
	password: 'editPasswordSuccess',
};

const SuccessStatusDialog = ({ operationType, onClose }: SuccessStatusDialogProps) => {
	const statusLabels = useSelector(getErrorSuccessLoaderLabels);
	const operationLabel = statusLabels?.successMessages?.[labelsMap[operationType]];

	return (
		<CustomConfirmationDialog
			isNewDashBoardEnabled
			isOpen
			header={<>{statusLabels?.successMessages?.title}</>}
			hideDialog={onClose}
			width={500}
			padding="0px 16px 24px"
		>
			<>{operationLabel}</>
		</CustomConfirmationDialog>
	);
};

export default SuccessStatusDialog;
